import { useCallback, useEffect, useRef } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { TextLabel } from '../TextLabel';
import { IDropdownMenuItem } from './DropdownMenu.model';
import { StyledContainer, StyledItem } from './DropdownMenu.styled';

const DropdownMenu = ({
	items,
	closeHandler,
}: {
	items: IDropdownMenuItem[];
	closeHandler?: () => void;
}) => {
	const menuRef = useRef<HTMLDivElement>(null);

	const handleClick = useCallback(
		(index: number) => {
			items[index].onClick();

			if (closeHandler) {
				closeHandler();
			}
		},
		[items, closeHandler],
	);

	useEffect(() => {
		if (!closeHandler) {
			return;
		}

		function handleClickOutside(event: Event) {
			if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
				closeHandler?.();
			}
		}

		setTimeout(() => {
			document.addEventListener('click', handleClickOutside);
		}, 300);

		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, [menuRef, closeHandler]);

	return (
		<StyledContainer ref={menuRef}>
			{items.map((item, index) => (
				<StyledItem
					onClick={() => {
						handleClick(index);
						playSound(Sound.ClickButton);
					}}
					key={index}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				>
					<img src={item.icon} />
					<TextLabel>{item.title}</TextLabel>
				</StyledItem>
			))}
		</StyledContainer>
	);
};

export { DropdownMenu };
